<script lang="ts">
  import PdpSafeguardService from './PDPSafeguardService.svelte';

  export let data: any;
  export let labelData: any;
  export let lmdConfigurations: any;
</script>

<!-- Safeguard service in disguise!! -->
<PdpSafeguardService {data} {labelData} {lmdConfigurations} useAs="CareCoating" />
